var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForbidden(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.321 15.656A7.991 7.991 0 009.99 18a7.99 7.99 0 005.667-2.344c3.125-3.125 3.125-8.21 0-11.335s-8.21-3.125-11.335 0-3.125 8.21 0 11.335zm1.764-9.571A5.504 5.504 0 019.989 4.47a5.52 5.52 0 012.922.833l-7.608 7.608a5.531 5.531 0 01.782-6.826zm8.589.981l-7.608 7.608a5.53 5.53 0 006.827-.78 5.531 5.531 0 00.78-6.828z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default ForwardRef;